import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";
import { buildCompanyPlanRequestQuery } from "src/site/companyPlanRequestQuery";

// landIeul: components/CompanyIndex/BottomCta/index.tsx。
// STEP1(土地の有無) → STEP2(エリア→都道府県) を選ぶと plan-request へ遷移する。
const ACTIVE = "IndexBottomCta_active";
const ACTIVE_PARTS = "IndexBottomCta_activeParts";
const ACTIVE_BUTTON = "IndexBottomCta_activeButton";

class SiteCompanyIndexBottomCtaController extends Controller {
  static targets = ["step2Box", "step2Text", "areaGroup", "cityGroup", "prevBtn", "startWrap", "startBtn"];
  static values = { prefectures: Object, medium: String, term: String };

  declare readonly step2BoxTarget: HTMLElement;
  declare readonly step2TextTarget: HTMLElement;
  declare readonly areaGroupTarget: HTMLElement;
  declare readonly cityGroupTarget: HTMLElement;
  declare readonly prevBtnTarget: HTMLButtonElement;
  declare readonly startWrapTarget: HTMLElement;
  declare readonly startBtnTarget: HTMLButtonElement;
  declare readonly prefecturesValue: Record<string, { id: string; name: string }[]>;
  declare readonly mediumValue: string;
  declare readonly termValue: string;

  private active = -1;
  private areaId = "";
  private prefectureId = "";

  selectLand(e: Event): void {
    const btn = e.currentTarget as HTMLElement;
    this.active = Number(btn.dataset.land);
    this.areaGroupTarget.parentElement?.querySelectorAll('[name="areabutton"]').forEach((b) => {
      (b as HTMLButtonElement).disabled = false;
    });
    // STEP1 の選択ボタンをアクティブ表示
    btn.parentElement?.querySelectorAll("button").forEach((b) => b.classList.remove(ACTIVE));
    btn.classList.add(ACTIVE);
    this.step2BoxTarget.classList.add(ACTIVE_PARTS);
    this.step2TextTarget.textContent =
      this.active === 1
        ? "土地からお探しの方は、まずはご希望のエリア、または現住所をご入力いただければ、最適なプランをご紹介します。"
        : "活用したい土地のエリアを入力してください";
  }

  selectArea(e: Event): void {
    const btn = e.currentTarget as HTMLButtonElement;
    this.areaId = btn.dataset.areaId || "";
    this.prefectureId = "";
    this.areaGroupTarget.querySelectorAll("button").forEach((b) => b.classList.remove(ACTIVE));
    btn.classList.add(ACTIVE);
    this.areaGroupTarget.style.display = "none";
    this.renderPrefectures();
    this.prevBtnTarget.disabled = false;
    this.updateStart();
  }

  selectPref(e: Event): void {
    const btn = e.currentTarget as HTMLButtonElement;
    this.prefectureId = btn.value;
    this.cityGroupTarget.querySelectorAll("button").forEach((b) => b.classList.remove(ACTIVE));
    btn.classList.add(ACTIVE);
    this.updateStart();
  }

  resetArea(): void {
    this.areaId = "";
    this.prefectureId = "";
    this.areaGroupTarget.style.display = "";
    this.areaGroupTarget.querySelectorAll("button").forEach((b) => b.classList.remove(ACTIVE));
    this.cityGroupTarget.innerHTML = "";
    this.prevBtnTarget.disabled = true;
    this.updateStart();
  }

  planRequest(): void {
    const propertyTypeId = this.active === 0 ? "land_usage_yes" : "land_usage_no";
    const query = `&property-type-id=${propertyTypeId}&pref-id=${this.prefectureId}`;
    const trackingQuery = buildCompanyPlanRequestQuery(this.mediumValue, this.termValue);
    window.open(`/plan-request/?${trackingQuery}${query}`, "_self", "noreferrer");
  }

  private renderPrefectures(): void {
    this.cityGroupTarget.innerHTML = "";
    (this.prefecturesValue[this.areaId] || []).forEach((pref) => {
      const btn = document.createElement("button");
      btn.name = "prefecturebutton";
      btn.type = "button";
      btn.value = pref.id;
      btn.textContent = pref.name;
      btn.dataset.action = "site--company--index-bottom-cta#selectPref";
      this.cityGroupTarget.appendChild(btn);
    });
  }

  private updateStart(): void {
    this.startBtnTarget.disabled = !this.prefectureId;
    this.startWrapTarget.classList.toggle(ACTIVE_BUTTON, !!this.prefectureId);
  }
}

application.register("site--company--index-bottom-cta", SiteCompanyIndexBottomCtaController);
